<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Mic Off" class="d-icon d-icon--mic-off" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><g :clip-path="`url(#${uniqueID}a)`"><path fill="currentColor" fill-rule="evenodd" d="M.646.646a.5.5 0 0 1 .708 0l7.5 7.5 2.5 2.5a.5.5 0 0 1-.708.708L8.481 9.188a4 4 0 0 1-1.981.832V11H8a.5.5 0 0 1 0 1H4a.5.5 0 0 1 0-1h1.5v-.98A4.001 4.001 0 0 1 2 5.996V5a.5.5 0 0 1 1 0v1.007a3 3 0 0 0 4.768 2.468l-.753-.753A2 2 0 0 1 4 6V4.707L.646 1.354a.5.5 0 0 1 0-.708ZM5 5.707V6a1 1 0 0 0 1.258.965L5 5.707Zm.153-5.01A2 2 0 0 1 8 2.497V4.67a.5.5 0 0 1-1 0V2.502a1 1 0 0 0-1.893-.442.5.5 0 0 1-.894-.45 2 2 0 0 1 .94-.913ZM9.5 4.5a.5.5 0 0 1 .5.5v1.001c0 .235-.022.47-.063.702a.5.5 0 1 1-.984-.176A3.06 3.06 0 0 0 9 6V5a.5.5 0 0 1 .5-.5Z" clip-rule="evenodd"/></g><defs><clipPath :id="`${uniqueID}a`"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconMicOff',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
